<template>
  <section class="companies">
    <div class="al-tabs-container full-width">
      <div
        v-if="tabs.length > 1"
        class="al-tabs-title"
      >
        <template v-for="(tab) in tabs">
          <button
            :key="tab.id"
            class="button"
            :class="selectedTab === tab.id ? 'selected' : ''"
            @click="handleSelectTab(tab.id)"
          >
            {{ tab.title }}
          </button>
        </template>
      </div>
      <div class="al-tabs">
        <div
          v-if="selectedTab === allTabs.AI_LEAN_ADMINS"
          class="al-tab"
        >
          <ai-lean-admins />
        </div>
        <div
          v-if="selectedTab === allTabs.CS_ADMINS"
          class="al-tab"
        >
          <cs-admins />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Roles } from '@/constants';
import CsAdmins from './CSAdmins.vue';
import AiLeanAdmins from './AILeanAdmins.vue';

const TABS = {
  AI_LEAN_ADMINS: 'AI_LEAN_ADMINS',
  CS_ADMINS: 'CS_ADMINS'
};

export default {
  name: 'StateLocation',
  components: {
    CsAdmins,
    AiLeanAdmins
  },
  data() {
    return {
      role: this.$store.state.user.role,
      tabs: [],
      selectedTab: null,
      allTabs: TABS,
      roles: Roles
    };
  },
  mounted() {
    this.generateTabs();
  },
  methods: {
    handleSelectTab(key) {
      this.selectedTab = key;
    },
    generateTabs() {
      const tabs = [];

      tabs.push({
        id: TABS.AI_LEAN_ADMINS,
        title: 'AI Lean Admins',
        visible: true
      });
      tabs.push({
        id: TABS.CS_ADMINS,
        title: 'CS Admins',
        visible: true
      });
      this.tabs = [...tabs];
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped lang="scss">
.companies {
  display: flex;

  .is-borderless {
    border: 0;
  }

  .admin {
    width: 25%;
    position: relative;

    .info {
      position: sticky;
      top: 0;
      z-index: 2;
    }
  }

  .al-tabs-container {
    width: 75%;

    &.full-width {
      width: 100%;
    }
  }
}
</style>
